import { SubscriptionLevel } from '../lib/api';

interface UserBadgeProps {
  // user_level removed - see #785
  subscription_level?: SubscriptionLevel | null;
  size?: 'xs' | 'sm';
  className?: string;
}

// DORMANT — private badges, see #3356
/**
 * UserBadge — renders null.
 *
 * Kept for a possible private, self-facing badge feature (#3356; owner
 * decision on #3355, 2026-09-08). Badges will NOT be public: the only render
 * site is the signed-in user's own ProfilePage. Do not add it to
 * PublicProfilePage or any other surface another user can see.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- #3356 dormant: props reserved for the private badge design
export default function UserBadge(_props: UserBadgeProps) {
  return null;
}
